import { action as apiAction } from 'api/Api'
import createSortedCardsInStatusSelector from '../selectors/createSortedCardsInStatusSelector'
import {
  setStatus as setCardStatus,
  setStatusPositions,
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'
import sweetalert from 'sweetalert2'

type Payload = {
  boardId: number
  id: number
  statusId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { boardId, id, statusId } = payload

  const state = getState()

  if (state['view-board'].cards[id].boardId === boardId) { // Same board
    const cards = createSortedCardsInStatusSelector(() => statusId)(state)

    const optimisticAction = optimisticDispatch(dispatch, [
      setCardStatus({
        id,
        statusId
      }),
      setStatusPositions([{
        id,
        position: cards[0] ? cards[0].statusPosition - 100 : 1
      }])
    ])

    try {
      await apiAction('SetCardStatus', {
        cardId: id,
        cardStatusId: statusId,
        position: 'top',
      })
      
      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      if (error.code === 539) { // Card is blocked
        try {
          await sweetalert({
            text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
            type: 'info'
          })
        } catch (e) {}
      } else if (error.code !== 302) { // Source and target are the same
        throw error
      }
    }
  } else { // Other board
    const optimisticAction = optimisticDispatch(dispatch, setCardStatus({
      id,
      statusId,
    }))

    try {
      await apiAction('MoveCard', {
        targetStatusId: statusId,
        cardId: id,
        position: 'top',
        allowFilesRemove: true,
        copyFiles: true
      })

      optimisticAction.commit()
    } catch (error) {
      optimisticAction.revert()

      if (error.code === 539) { // Card is blocked
        try {
          await sweetalert({
            text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
            type: 'info'
          })
        } catch (e) {}
      } else {
        throw error
      }
    }
  }
}
